import { Box, useTheme } from "@mui/material";
import FlexCenter from "../flex/flex-center";
import { CircleX } from "lucide-react";
import Player from '../player';

type PlayerItemProps = {
    isAdmin: boolean;
    onKick: (arg0:string) => void;
    player: string;
    me: string;
};

export default function PlayerItem({isAdmin, onKick, player, me} : PlayerItemProps) {
    const theme = useTheme();
    
    return (
        <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} paddingRight={{ xs: 1, sm: 1.5, md: 2 }} sx={{ width: '100%', minWidth: 0 }}>
            <FlexCenter direction="row" sx={{ minWidth: 0, overflow: 'hidden' }}>
                <Player player={player} />
            </FlexCenter>
            {isAdmin && me !== player && (
                <Box color={theme.palette.error.light} sx={{ cursor: "pointer", flexShrink: 0, ml: 0.5 }} onClick={() => onKick(player)}>
                    <CircleX size={18} />
                </Box>
            )}
        </Box>
    );
}
